/* eslint-disable */
import Vue from 'vue'
import Rx from 'rxjs/Rx'
import VueRx from 'vue-rx'
Vue.use(VueRx, Rx)
import axios from 'axios'

/**
 * post data to direct express facade 
 * in json format. 
 * from express facade to mysql backend 
 * the request's content-type will be changed into 
 * application/x-www-form-urlencoded 
 * and the Json object sringified and saved under 
 * the '_x' attribute in the request to 
 * come around IE 11 bug
 */
const defaultPOSTHeader = {
  common: {
    'Content-Type': 'application/json;charset=utf-8',
    'Origin': 'https://localhost:8080'
  }
}
const defaultGETHeader = {
  common: {
    'Origin': 'https://localhost:8080'
  }
}

/**
 * - params must be passed as object literals
 * - headers must be passed in the format
 *    {
 *        'Authorization': 'Bearer 5r67nr67r67r67n'
 *    }
 * 
 * @param {*} url 
 * @param {*} headers 
 * @param {*} params 
 */
export const post = (url, params, headers) => {
  params = (! params) ? {} : params
  delete params.router
  // console.log('header/s===>',headers)

  if(headers == '' || headers == undefined){
    headers = {};
    headers['x-auth-token'] = '207f3453e6f18c02eb970394b520f60f-ht6950a408bc46ee5f891f12f665189f12e9b50c920fab1ce0d7adb497439a493e0f06f61e29339bb31bb15ba37f540bbde31b317d1b15d4312629104d3fe189'
      delete  axios.defaults.headers.common.Authorization  ;
  }else{
    delete  axios.defaults.headers.common['x-auth-token']  ;
  }
  // console.log('headers1111===>',headers)

  // axios.defaults.headers.common = headers
  axios.defaults.headers.common = defaultPOSTHeader
  if (headers) {
   // console.log(headers)
    for (let h in headers) {
      // console.log('22222',headers[h])
      axios.defaults.headers.common[h] = headers[h]
    }
	}
  /*return Rx.Observable.fromPromise(
    axios.post(url, params)

  )*/

   return Rx.Observable.fromPromise(
    axios.post(url, params)
    .then(response => { 
      return response;
    })
    .catch(error => {
      let returnData = {data:{"info":"NOK","msg":error.message,"data":{},"errors":error}}
      if (error.response) {
        if(error.response.status == 401){
          returnData.data.status = 401
        }
      }
      return returnData;
    })
    
  )

}

/**
 * - params must be passed as object literals
 * - headers must be passed in the format
 *    {
 *        'Authorization': 'Bearer 5r67nr67r67r67n'
 *    }
 * 
 * @param {*} url 
 * @param {*} headers 
 * @param {*} params 
 */
export const get = (url, headers, params) => {
// console.log(params,'header/s===>',headers)
  params = (! params) ? {} : params
  delete params.router
  


   // headers = {};
   //  headers['x-auth-token'] = '207f3453e6f18c02eb970394b520f60f-ht6950a408bc46ee5f891f12f665189f12e9b50c920fab1ce0d7adb497439a493e0f06f61e29339bb31bb15ba37f540bbde31b317d1b15d4312629104d3fe189'
  // console.log('headers1111===>',headers)

  // axios.defaults.headers.common = headers
  // axios.defaults.headers.common = defaultPOSTHeader
  if (headers) {
   // console.log(headers)
    for (let h in headers) {
      // console.log('22222',headers[h])
      axios.defaults.headers.common[h] = headers[h]
    }
  }
  // console.log(axios.defaults.headers.common.Authorization,'header/s=22==>',headers)
  return Rx.Observable.fromPromise(
    axios.get(url, params)
    .then(response => { 
      return response;
    })
    .catch(error => {
      console.log(error.message)
      let returnData = {data:{"info":"NOK","msg":error.message,"data":{},"errors":error}}
      if (error.response) {
        if(error.response.status == 401){
          returnData.data.status = 401
        }
      }
      return returnData;
    })
    
  )
 
}

/**
 * load json resource from local or remote url
 * @param {*} url 
 * @param {*} headers 
 * @param {*} params 
 */
export const getJson = (url, headers, params) => {
  params = (! params) ? {} : params
  // set default headers
  axios.defaults.headers.common = defaultGETHeader  
  if (headers) {
    for (let h in headers) {
      // add extra headers
      axios.defaults.headers.common[h] = headers[h]
    }
  }
  return Rx.Observable.fromPromise(
    axios.get(url,
      {
        data: params
      }
    )
  )
}



// WEBPACK FOOTER //
// ./src/store/api/rx-factory.js